/** Page enter motion shared by intro/outro and subchapter content. */
export const contentEnterClass =
  "motion-safe:animate-in motion-safe:fade-in-0 motion-safe:slide-in-from-bottom-4 motion-safe:duration-500";
